import { render, staticRenderFns } from "./WarehouseResetCommands.vue?vue&type=template&id=2be3a4a0&"
import script from "./WarehouseResetCommands.vue?vue&type=script&lang=ts&"
export * from "./WarehouseResetCommands.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports